import * as React from "react";
const SvgFiRrArrowToTop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-arrow-to-top_svg__a)">
      <path
        fill="#062147"
        d="M6 2.031h4.517q-.152.106-.285.232l-4.95 4.95A1.001 1.001 0 1 0 6.7 8.627l4.3-4.3V23a1 1 0 0 0 2 0V4.324l4.3 4.3a1 1 0 0 0 1.413-1.414l-4.95-4.95a2.5 2.5 0 0 0-.284-.232h4.52a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-arrow-to-top_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrArrowToTop;
